// Fachada de uso da equipe — métodos do repo (ver core.ts).
import { teamUsageRepo } from './core';

export type { TeamUsageRow } from '@modules/teamUsage';

export const touchActiveDay = teamUsageRepo.touchActiveDay;
export const getTeamUsage   = teamUsageRepo.getTeamUsage;
